const SVG_NS = 'http://www.w3.org/2000/svg';

function createSvgElement(tagName, attributes = {}) {
  const element = document.createElementNS(SVG_NS, tagName);
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, String(value)));
  return element;
}

export function createMessageActionIcon(name, { size = 13, strokeWidth = 2 } = {}) {
  const svg = createSvgElement('svg', {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': strokeWidth,
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'aria-hidden': 'true',
  });

  const shapes = {
    check: [createSvgElement('polyline', { points: '20 6 9 17 4 12' })],
    copy: [
      createSvgElement('rect', { x: 9, y: 9, width: 13, height: 13, rx: 2 }),
      createSvgElement('path', { d: 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' }),
    ],
    up: [createSvgElement('path', { d: 'M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3' })],
    down: [createSvgElement('path', { d: 'M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17' })],
    regenerate: [
      createSvgElement('polyline', { points: '23 4 23 10 17 10' }),
      createSvgElement('polyline', { points: '1 20 1 14 7 14' }),
      createSvgElement('path', { d: 'M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15' }),
    ],
    toastSuccess: [
      createSvgElement('path', { d: 'M22 11.08V12a10 10 0 1 1-5.93-9.14' }),
      createSvgElement('polyline', { points: '22 4 12 14.01 9 11.01' }),
    ],
    toastError: [
      createSvgElement('circle', { cx: 12, cy: 12, r: 10 }),
      createSvgElement('line', { x1: 15, y1: 9, x2: 9, y2: 15 }),
      createSvgElement('line', { x1: 9, y1: 9, x2: 15, y2: 15 }),
    ],
  };

  svg.append(...(shapes[name] || []));
  return svg;
}

export function renderCopyBubbleIcon(button, copied = false) {
  if (!button) return;
  button.replaceChildren(createMessageActionIcon(copied ? 'check' : 'copy', {
    size: 14,
    strokeWidth: copied ? 2.5 : 2,
  }));
}

export function renderTemporaryCopyAction(button) {
  if (!button) return () => {};
  const originalNodes = Array.from(button.childNodes, (node) => node.cloneNode(true));
  button.replaceChildren(
    createMessageActionIcon('check', { size: 13, strokeWidth: 2.5 }),
    document.createTextNode(' 已复制'),
  );
  return () => button.replaceChildren(...originalNodes);
}

export function renderFeedbackAction(button, action, active = false) {
  if (!button) return;
  const label = action === 'up' ? '有用' : '有误';
  button.replaceChildren(
    ...(active ? [] : [createMessageActionIcon(action)]),
    document.createTextNode(`${active ? '✓' : ''} ${label}`.trimStart()),
  );
}

export function renderHeaderBadge(root, model) {
  if (!root) return;
  const dot = document.createElement('span');
  dot.className = 'aichat-dot';
  root.replaceChildren(dot, document.createTextNode(` ${model || 'AI'}`));
}

export function createToastElement(message, type = 'success') {
  const toast = document.createElement('div');
  toast.className = `aichat-toast aichat-toast--${type}`;
  const icon = createMessageActionIcon(type === 'success' ? 'toastSuccess' : 'toastError', { size: 24 });
  const label = document.createElement('span');
  label.textContent = message;
  toast.append(icon, label);
  return toast;
}
